import TotalCard from 'Pages/reports/[submodules]/employees/components/TotalCard/TotalCard';
import { TotalEmployeeHistoryDetailsWrapper } from './TotalEmployeeHistoryDetails.styled';
import SchoolIcon from '@mui/icons-material/School';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import PendingActionsIcon from '@mui/icons-material/PendingActions';
import PlayCircleOutlineIcon from '@mui/icons-material/PlayCircleOutline';
import EventBusyIcon from '@mui/icons-material/EventBusy';
import QueryBuilderIcon from '@mui/icons-material/QueryBuilder';
import useTranslation from 'Hooks/useTranslation';
import type { HistoryEmployeeReportTotalsI } from 'types';
import { buildTime } from 'Pages/reports/utils/buildTime';

interface Props {
  totals: HistoryEmployeeReportTotalsI;
}

const TotalEmployeeHistoryDetails = ({ totals }: Props) => {
  const { t2 } = useTranslation('history_employee_report');
  const trainingHours = buildTime(totals?.totalTrainingHours, t2);

  return (
    <TotalEmployeeHistoryDetailsWrapper>
      <TotalCard
        value={totals.totalCourses}
        label={t2('total_courses')}
        icon={<SchoolIcon />}
        description={t2('total_courses_description')}
      />
      <TotalCard
        value={totals.completedCourses}
        label={t2('completed_courses')}
        icon={<TrendingUpIcon />}
        description={t2('completed_courses_description')}
      />
      <TotalCard
        value={totals.currentCourses}
        label={t2('current_courses')}
        icon={<PlayCircleOutlineIcon />}
        description={t2('current_courses_description')}
      />
      <TotalCard
        value={totals.pendingCourses}
        label={t2('pending_courses')}
        icon={<PendingActionsIcon />}
        description={t2('pending_courses_description')}
      />
      <TotalCard
        value={totals.expiredCourses}
        label={t2('expired_courses')}
        icon={<EventBusyIcon />}
        description={t2('expired_courses_description')}
      />
      <TotalCard
        value={trainingHours}
        label={t2('total_training_hours')}
        icon={<QueryBuilderIcon />}
        description={t2('total_training_hours_description')}
      />
    </TotalEmployeeHistoryDetailsWrapper>
  );
};

export default TotalEmployeeHistoryDetails;
